
<template>
  <div class="animated fadeIn">
    <p>
      <!-- Exit -->
      初期設定後、いつでも設定を変更することが可能です。
      <b-button class="float-right" variant="link" @click="$parent.$emit('status', false)">クイックガイド Exit</b-button>
    </p>
    <b-card-group>
      <!-- .slideInDown
      .slideInLeft
      .slideInRight
      .slideInUp
      .slideOutDown
      .slideOutLeft
      .slideOutRight
      .slideOutUp -->
      <b-card v-if="step == 1" class="slideInDown slideOutDown">
        <!-- 안내 및 설정 방법 -->
        <b-row>
          <b-col class="text-center">
            <h3>
              はじめまして。新しいエージェントが導入されました！
            </h3>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12" class="text-center">
            <b-card-group deck style="cursor:pointer">
              <b-card bg-variant="primary" @click="list">
                <b-card-text>
                  <strong>他のポリシーからコピー</strong>
                  <hr>
                  <p>異なるWSFinderの設定を適用</p>
                  <hr>
                  <p>
                    [エージェントを選択] -> [設定] -> [他のサーバーに適用] -> [適用]
                  </p>
                </b-card-text>
              </b-card>
              <b-card bg-variant="success" @click="next()">
                <b-card-text>
                  <strong>
                     ポリシー設定
                  </strong>
                  <hr>
                  <p>すぐにセットアップして、サーバに隠されたWebshellを見つけてください。</p>
                  <hr>
                  <p>アンチWebShellの設定を開始</p>
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 2" class="slideInLeft slideOutLeft">
        <h4>* サーバ上のアップロードディレクトリを選択する</h4>
        <hr>
        <!-- {{scan_list}} -->
        <!-- 폴더 설정 설정 -->
        <folder-set
          :only_view="true"
          :show="dir.length"
          :item="dir"
          :scan_list="scan_list"
          :white_path="white_path"

          @path="(s) => $parent.$emit('get_path', s)"
          @remove="(type, s) => remove_select(type, s) && $parent.$emit('remove', type, s)"
          @clear="() => $parent.$emit('clear')"

          @add_white_list="add_white_list"
          @add_scan_list="add_scan_list"
          @white_path_one="white_path_one"

        >
        </folder-set>
      </b-card>

      <b-card v-if="step == 3" class="slideInLeft slideOutLeft">
        <!-- 점검 정책 설정해야 함 -->
        <b-row style="height:180px;">
          <b-col md="5" class="text-right">
            <center>
              <div :style="style('RoyalBlue')" style="position:relative;top:50px;left:+60px;" @click="rule_update('Regex')" >
                <span v-if="rule.indexOf('Regex') > -1">&#10003;</span>
                正規表現
              </div>
              <div :style="style('crimson')" style="position:relative;top:-10px;" @click="rule_update('Hash')" >
                <span v-if="rule.indexOf('Hash') > -1">&#10003;</span>
                ハッシュ
              </div>
              <div :style="style('skyblue')" style="position:relative;top:50px;left:-60px;" @click="rule_update('Url')" >
                <span v-if="rule.indexOf('Url') > -1">&#10003;</span>
                URL
              </div>
            </center>
          </b-col>
          <b-col>
            <p style="margin-top:18px; font-size:55px;">
              +
            </p>
          </b-col>

          <b-col md="5" class="text-left">

            <!-- @click="rule_update('Ssdeep')" -->
            <div :style="style('gold')">
              <span v-if="rule.indexOf('Ssdeep') > -1">&#10003;</span>
              SSDEEP
            </div>
            <!-- @click="rule_update('OB')" -->
            <div :style="style('orange')">
              <span v-if="rule.indexOf('OB') > -1">&#10003;</span>
              <small class="font-weight-bold">難読化</small>
            </div>
            <p class="mt-3">
              * クイック設定は、オプションに対応していません。
              <br>
              クイック設定後、詳細設定にて追加設定が可能です
              <!-- 検出された場合、チェックファイルが必要です -->
            </p>

          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col>
            * 「サークル」または「次へ」をクリック(Default : [{{rule_text}}])
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 4" class="slideInLeft slideOutLeft">
        <!-- 백업 모드 및 백업 경로 -->
        <b-row class="text-center">
          <b-col>
            * スケジューリングのためのオプション設定です。
            検出されたファイルの検疫を特定のパスに設定することができます。
            <br>
            <br>
            サイトコードに悪意のあるパターンがある場合、物理ファイルを隔離しているため、サイトに問題がある可能性があります。
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="4">
            * 分離のためにフルパスを入力してください。
            <br>
            <span class="text-danger font-weight-bold">* フォルダはすで存在します</span>
          </b-col>
          <b-col md="8">
            <b-form-input v-model="isolation" placeholder="/etc/var/isolation or C:\\www\\isolation"></b-form-input>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 5" class="slideInLeft slideOutLeft">
        <b-row class="text-center">
          <b-col>
            * スケジューリングのためのオプション設定です
          </b-col>
        </b-row>
        <hr>
        <!-- 스케줄 설정 -->
        <b-row class="text-center">
          <b-col>
            検査スケジュールを選択してください
          </b-col>
          <b-col>
            <Schedule :now_schedule="schedule" @save="x => { this.schedule = x }"/>
          </b-col>
        </b-row>
      </b-card>
    </b-card-group>
    <!-- 스탭 공통 처리 부분 -->
    <hr v-if="step < all">
    <b-button v-if="step > 1" block size="sm" variant="info" @click="prev()"> 前へ </b-button>
    <b-button v-if="step < all"  block size="sm" variant="primary" @click="next()">次へ </b-button>
    <b-button class="btn-add" v-else block size="sm" variant="success" @click="modal_save = true">保存 </b-button>
    <hr>
    <b-row>
      <b-col>
        <center>{{step}} / {{all}}</center>
      </b-col>
    </b-row>
    <b-modal title="この設定はエージェントに適用されます(アンチWebシェル))"  class="modal-success" v-model="modal_save" @ok="apply" ok-variant="success" header-bg-variant="warning">
      設定を適用しますか？
      <hr>
      設定が保存されたら
      <br>
      「チェック」タブで確認することができます。
      <br>
      設定はいつでも変更可能です。
    </b-modal>
    <!-- 디버그 영역 -->
    <!-- {{}} -->
  </div>
</template>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
